var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-rw",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#20603d",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fad201",
    d: "M0 0h512v384H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a1de",
    d: "M0 0h512v256H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(374.4 133.8) scale(.7111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "#e5be01",
    d: "M116.1 0 35.7 4.7l76.4 25.4-78.8-16.3L100.6 58l-72-36.2L82 82.1 21.9 28.6l36.2 72-44.3-67.3L30 112 4.7 35.7 0 116.1-1-1z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "scale(1 -1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 34.3,
    fill: "#e5be01",
    stroke: "#00a1de",
    strokeWidth: 3.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRw);
export default __webpack_public_path__ + "static/media/rw.43b11a92e4daed9a53c4c3897beb6f51.svg";
export { ForwardRef as ReactComponent };